/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalUserNameUpdateResponse
 */
export interface ExternalUserNameUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof ExternalUserNameUpdateResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserNameUpdateResponse
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the ExternalUserNameUpdateResponse interface.
 */
export function instanceOfExternalUserNameUpdateResponse(value: object): value is ExternalUserNameUpdateResponse {
    return true;
}

export function ExternalUserNameUpdateResponseFromJSON(json: any): ExternalUserNameUpdateResponse {
    return ExternalUserNameUpdateResponseFromJSONTyped(json, false);
}

export function ExternalUserNameUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserNameUpdateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
    };
}

export function ExternalUserNameUpdateResponseToJSON(json: any): ExternalUserNameUpdateResponse {
    return ExternalUserNameUpdateResponseToJSONTyped(json, false);
}

export function ExternalUserNameUpdateResponseToJSONTyped(value?: ExternalUserNameUpdateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'displayName': value['displayName'],
    };
}

